module.exports = __webpack_public_path__ + "static/media/Ellipse 3.55d38662.png";